import "./DaEmailRequestPaused.css";
import { Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import DaPageWrapper from "../DaPageWrapper/DaPageWrapper";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { translateStatic } from "../../hooks/useT/useT";

const formatRemainingTime = (remainingSeconds) => {
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

const DaEmailRequestPaused = ({ retryAfterSeconds = 300, onRequestNewLink, isBusy = false }) => {
  const [deadline, setDeadline] = useState(() => Date.now() + retryAfterSeconds * 1000);
  const [remainingSeconds, setRemainingSeconds] = useState(() => Math.max(0, Math.ceil(retryAfterSeconds)));
  const isPaused = remainingSeconds > 0;

  useEffect(() => {
    setDeadline(Date.now() + retryAfterSeconds * 1000);
    setRemainingSeconds(Math.max(0, Math.ceil(retryAfterSeconds)));
  }, [retryAfterSeconds]);

  useEffect(() => {
    let timer;
    const updateRemainingSeconds = () => {
      const nextRemainingSeconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      setRemainingSeconds(nextRemainingSeconds);
      if (nextRemainingSeconds === 0 && timer) window.clearInterval(timer);
    };

    updateRemainingSeconds();
    if (deadline <= Date.now()) return undefined;

    timer = window.setInterval(() => {
      updateRemainingSeconds();
    }, 1000);

    return () => window.clearInterval(timer);
  }, [deadline]);

  return (
    <DaPageWrapper
      wrapperClass="da-email-paused-card da-page-wrapper"
      iconType="mail"
      title={<Translate tKey={T_KEYS.DA.EMAIL_REQUEST_PAUSED.TITLE} />}
      subtitle={<Translate tKey={T_KEYS.DA.EMAIL_REQUEST_PAUSED.DESCRIPTION} />}
    >
      <Typography variant="caption" color="text.secondary" className="da-email-paused-wait">
        <span>{translateStatic(T_KEYS.DA.EMAIL_REQUEST_PAUSED.WAIT)} </span>
        <strong className="da-email-paused-timer">{formatRemainingTime(remainingSeconds)}</strong>
      </Typography>
      <Button
        type="button"
        variant="outlined"
        className="da-email-paused-request"
        disabled={isPaused || isBusy}
        onClick={onRequestNewLink}
      >
        {translateStatic(T_KEYS.DA.EMAIL_REQUEST_PAUSED.REQUEST_NEW_LINK)}
      </Button>
    </DaPageWrapper>
  );
};

DaEmailRequestPaused.propTypes = {
  retryAfterSeconds: PropTypes.number,
  onRequestNewLink: PropTypes.func.isRequired,
  isBusy: PropTypes.bool,
};

export { DaEmailRequestPaused };
